import { render } from "./CardBoxComponentRestricted.vue?vue&type=template&id=f0ddd428"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__